import { createIcon } from './createIcon';

const svg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 8C0 3.58172 3.58172 0 8 0H12C16.4183 0 20 3.58172 20 8V12C20 16.4183 16.4183 20 12 20H8C3.58172 20 0 16.4183 0 12V8Z"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M13.332 6.66699H8.33203C7.89 6.66699 7.46608 6.84259 7.15352 7.15515C6.84096 7.46771 6.66536 7.89163 6.66536 8.33366C6.66536 8.77569 6.84096 9.19961 7.15352 9.51217C7.46608 9.82473 7.89 10.0003 8.33203 10.0003H11.6654C12.1074 10.0003 12.5313 10.1759 12.8439 10.4885C13.1564 10.801 13.332 11.225 13.332 11.667C13.332 12.109 13.1564 12.5329 12.8439 12.8455C12.5313 13.1581 12.1074 13.3337 11.6654 13.3337H6.66536M9.9987 14.5837V5.41699M3.33203 1.66699V18.3337L4.9987 17.5003L6.66536 18.3337L8.33203 17.5003L9.9987 18.3337L11.6654 17.5003L13.332 18.3337L14.9987 17.5003L16.6654 18.3337V1.66699L14.9987 2.50033L13.332 1.66699L11.6654 2.50033L9.9987 1.66699L8.33203 2.50033L6.66536 1.66699L4.9987 2.50033L3.33203 1.66699Z"
      stroke="#09090B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DollarOutlinedIcon = createIcon(() => svg());

export default DollarOutlinedIcon;
